// Homepage data for HIG Automation.
// Edit this file to change homepage statistics, trust badges, project highlights,
// reasons to choose HIG Automation, and the main homepage images.

export const trustBadges = [
  "Made in India",
  "Delhi NCR Based",
  "150+ Projects Delivered",
  "22+ Engineers",
  "Turnkey Execution",
];

export const heroStats = [
  { value: "150+", label: "Projects Delivered" },
  { value: "22+", label: "Expert Engineers" },
  { value: "7+", label: "Marquee Clients" },
  { value: "800", label: "sqm Facility (2026)" },
];

export const capabilities = [
  {
    title: "Pipeline Turnkey Projects",
    image:
      "https://images.unsplash.com/photo-1620203853151-496c7228306c?crop=entropy&cs=srgb&fm=jpg&q=85",
    description:
      "MS, GI, SS & pneumatic system layouts, fire hydrant lines, colour-coded utility piping — complete site to completion execution.",
  },
  {
    title: "Electrical & Structural Works",
    image:
      "https://images.unsplash.com/photo-1701328778019-e95dedbf5346?crop=entropy&cs=srgb&fm=jpg&q=85",
    description:
      "Electric cabling, plant lighting, structural steelwork, cable trays, and complete switchgear panel builds.",
  },
  {
    title: "Fire Protection Systems",
    image:
      "https://images.unsplash.com/photo-1761195696590-3490ea770aa1?crop=entropy&cs=srgb&fm=jpg&q=85",
    description:
      "Pre-action sprinkler systems, fire hydrant networks, pump rooms, and industrial fire protection installations.",
  },
  {
    title: "Special Purpose Machines",
    image:
      "https://images.unsplash.com/photo-1610891015188-5369212db097?crop=entropy&cs=srgb&fm=jpg&q=85",
    description:
      "Custom SPMs for automotive, electronics, and metal-fabrication assembly lines — designed, built and commissioned in-house.",
  },
];

export const whyUs = [
  {
    title: "Speed-to-Delivery",
    description:
      "Fast turnaround from order to commissioning — minimising your production disruption.",
  },
  {
    title: "End-to-End Capability",
    description:
      "Design → Fabricate → Install → Commission → Maintain. All under one roof, one team.",
  },
  {
    title: "Trusted Partnerships",
    description:
      "Long-term relationships with clients including Honda, Siemens, JBM Group & Craftsman.",
  },
  {
    title: "Quality-First Culture",
    description:
      "Every project meets stringent quality norms — from material selection to final testing.",
  },
  {
    title: "Fastest-Growing Firm",
    description:
      "Strong execution and client trust support our rapid growth from the first year of operations.",
  },
  {
    title: "12+ Years Expertise",
    description:
      "Engineers with combined field experience across automotive & heavy manufacturing.",
  },
];

export const heroImage =
  "https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&q=85";

export const aboutImage =
  "https://images.unsplash.com/photo-1717386255773-1e3037c81788?crop=entropy&cs=srgb&fm=jpg&q=85";

// Product brands and product families.
// To add or remove a product later, edit only the products array
// inside the relevant brand. Header.jsx and Products.jsx read this automatically.
